import { jsx, Fragment } from './jsx-runtime'

export { Fragment }
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- JSX dev factory: type is heterogeneous; isStaticChildren/source/self are React compat params we don't use
export function jsxDEV(type: any, props: Record<string, unknown>, key: unknown, _isStaticChildren: boolean, _source: unknown, _self: unknown) {
    return jsx(type, props, key)
}
